module.exports = __webpack_public_path__ + "img/CG.e6f61257.svg";